/**
 * Hotkeyword Template
 * @category Hotkeyword
 */
class HotkeywordTempl {
    /**
     * Hotkeyword Templ
     * @param  {Object} _d={}
     */
    static getTempl(_d={}) {
        const itemList = _d[0].list.map( HotkeywordTempl.item ).join('');
        return `
          <button class="hotkeyword-toggle">
          <svg xmlns="http://www.w3.org/2000/svg" class="svg" viewBox="0 0 13 7"><path d="M6.194 6.806a.433.433 0 0 0 .612-.612L.74.127A.433.433 0 0 0 .127.74l6.067 6.066zm0-.612a.433.433 0 0 0 .612.612L12.873.74a.433.433 0 0 0-.613-.613L6.194 6.194z"/></svg>
</button>
          <ol class="hotkeyword-list is-rolling">${itemList}</ol>
          <ol class="hotkeyword-list is-layer">${itemList}</ol>`;
    }

    static item(_d, _idx){
        return `
          <li class="hotkeyword-item" data-idx="${_idx}">
              <a href="/search/index?keyword=${encodeURIComponent(_d[0])}" class="hotkeyword-item-link">
                  <em class="hotkeyword-item-title">${_d[0]}</em>
                  <span class="hotkeyword-item-rank is-${_d[1]}">${(_d[1] === 'same')? '-': _d[2]}</span>
              </a>
          </li>`;
    }

} // end of class

export default HotkeywordTempl;